import { render } from "./MyTabs.vue?vue&type=template&id=76f27b76&scoped=true"
import script from "./MyTabs.vue?vue&type=script&lang=js"
export * from "./MyTabs.vue?vue&type=script&lang=js"

import "./MyTabs.vue?vue&type=style&index=0&id=76f27b76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f27b76"]])

export default __exports__